import { useCallback } from 'react';

export function useShare() {
  const shareNative = useCallback(async (text: string, url?: string) => {
    if (navigator.share) {
      try {
        await navigator.share({ text, url: url || window.location.href });
      } catch (e) {
        console.log('Share cancelled');
      }
    }
  }, []);

  const shareTwitter = useCallback((text: string) => {
    const encoded = encodeURIComponent(text);
    window.open(`https://twitter.com/intent/tweet?text=${encoded}`, '_blank');
  }, []);

  const shareTelegram = useCallback((text: string) => {
    const encoded = encodeURIComponent(text);
    window.open(`https://t.me/share/url?text=${encoded}`, '_blank');
  }, []);

  const copyToClipboard = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  }, []);

  return { shareNative, shareTwitter, shareTelegram, copyToClipboard };
}
